import SectionHeading from "@/components/base/SectionHeading";
import { categories } from "@/pages/home/data";

export default function CategoriesSection() {
  return (
    <section id="categories" className="scroll-mt-20 w-full px-4 md:px-8 py-16 md:py-24 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="主题分类"
          title="按主题归档，投稿时选对方向"
          description="投稿时需要先选择主题分类，分类决定内容归入哪个频道以及适用哪几项审核标准。若同时涉及多个主题，请选择与核心事实最贴近的一项。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href="#contact"
              className="group flex flex-col p-5 md:p-6 rounded-lg bg-background-100 border border-background-200 hover:border-accent-400 hover:bg-accent-50/60 transition-colors cursor-pointer"
            >
              <div className="flex items-start justify-between gap-3">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-2xl group-hover:bg-accent-500 group-hover:text-secondary-950 transition-colors">
                  <i className={cat.icon} aria-hidden="true"></i>
                </span>
                <span className="text-xs font-medium text-foreground-500 px-2.5 py-1 rounded-full bg-background-200 whitespace-nowrap">
                  {cat.count}
                </span>
              </div>
              <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                {cat.name}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600 flex-1">
                {cat.desc}
              </p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-primary-600">
                按此分类投稿
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" aria-hidden="true"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}